import { render, staticRenderFns } from "./UserEditActivityTab.vue?vue&type=template&id=6c0ecd74"
import script from "./UserEditActivityTab.vue?vue&type=script&lang=ts"
export * from "./UserEditActivityTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports